import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../headersService";


export const getRoundDetails = createAsyncThunk('getRoundDetails', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/drive/drive-detail/rounds/${obj.id}`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const roundDetailsSlice = createSlice({
    name: 'Round Details',
    initialState: {
        loading: false,
        roundDetails: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(getRoundDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getRoundDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.roundDetails = action.payload
        })
        builder.addCase(getRoundDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default roundDetailsSlice.reducer